import { DocumentPage } from '@/components/DocumentPage'

/**
 * Страница /terms — пользовательское соглашение (заглушка).
 */
export const TermsPage = () => (
  <DocumentPage title="Пользовательское соглашение">
    <p>Текст пользовательского соглашения будет размещён здесь.</p>
  </DocumentPage>
)

export default TermsPage
